import { CartAddEvent } from '@theme/events';

if (!customElements.get('whippd-box')) {
  customElements.define('whippd-box', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.chosen = [];
      this.busy = false;
      this.cards = [...this.querySelectorAll('[data-product]')];
      this.slots = [...this.querySelectorAll('[data-slot]')];
      this.submit = this.querySelector('[data-submit]');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || button.disabled || this.busy) return;
        const card = button.closest('[data-product]');
        if (button.matches('[data-add], [data-add-more]') && card && !card.hasAttribute('data-sold-out') && this.chosen.length < 3) this.chosen.push(card);
        else if (button.matches('[data-remove]')) {
          const index = this.chosen.lastIndexOf(card);
          if (index >= 0) this.chosen.splice(index, 1);
        } else if (button.matches('[data-slot]')) this.chosen.splice(Number(button.dataset.slot), 1);
        else if (button.matches('[data-clear]')) this.chosen = [];
        else if (button.matches('[data-submit]')) { this.addToCart(); return; }
        else return;
        this.querySelector('[data-success]').hidden = true;
        this.querySelector('[data-error]').hidden = true;
        this.render();
      }, { signal: this.controller.signal });
      this.render();
    }
    disconnectedCallback() { this.controller?.abort(); }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: this.dataset.currency || 'INR', maximumFractionDigits: 2 }).format(cents / 100);
    }
    render() {
      const left = 3 - this.chosen.length;
      const unavailable = this.hasAttribute('data-unavailable') || !this.dataset.variant;
      this.cards.forEach((card) => {
        const qty = this.chosen.filter((item) => item === card).length;
        card.classList.toggle('is-picked', qty > 0);
        card.querySelector('[data-selected]').hidden = !qty;
        card.querySelector('[data-add]').hidden = qty > 0;
        card.querySelector('[data-add]').disabled = this.busy || unavailable || !left || card.hasAttribute('data-sold-out');
        card.querySelector('.wb__quantity').hidden = !qty;
        card.querySelector('[data-quantity]').textContent = qty;
        card.querySelector('[data-add-more]').disabled = this.busy || unavailable || !left;
        card.querySelector('[data-remove]').disabled = this.busy;
      });
      this.slots.forEach((slot, index) => {
        const card = this.chosen[index];
        const img = slot.querySelector('img');
        const source = card?.querySelector('img');
        slot.classList.toggle('is-filled', !!card);
        slot.disabled = !card || this.busy;
        img.hidden = !source;
        if (source) img.src = source.currentSrc || source.src;
        slot.setAttribute('aria-label', card ? `Remove ${card.dataset.title} from slot ${index + 1}` : `Empty slot ${index + 1}`);
      });
      const list = this.querySelector('[data-chosen]');
      list.replaceChildren();
      this.cards.forEach((card) => {
        const quantity = this.chosen.filter((item) => item === card).length;
        if (!quantity) return;
        const row = document.createElement('li');
        const name = document.createElement('span');
        const qty = document.createElement('span');
        name.textContent = card.dataset.title;
        qty.textContent = `× ${quantity}`;
        row.append(name, qty);
        list.append(row);
      });
      this.querySelector('[data-status]').textContent = left ? `${this.chosen.length} of 3 scrubs selected · Pick ${left} more` : 'Your trio is ready!';
      this.querySelector('[data-mobile-status]').textContent = left ? `${this.chosen.length} / 3 chosen` : '3 / 3 · Box ready!';
      this.querySelector('[data-progress]').style.width = `${this.chosen.length / 3 * 100}%`;
      this.querySelector('[data-clear]').hidden = !this.chosen.length;
      this.querySelector('[data-clear]').disabled = this.busy;
      const saving = this.chosen.reduce((sum, card) => sum + Number(card.dataset.price), 0) - Number(this.dataset.price);
      this.querySelector('[data-saving]').hidden = left > 0 || saving <= 0;
      this.querySelector('[data-saving]').textContent = saving > 0 ? `You save ${this.money(saving)} on your picks` : '';
      this.submit.disabled = this.busy || unavailable || left > 0;
      this.submit.textContent = this.busy ? 'Adding your box…' : unavailable ? 'Trio currently unavailable' : left ? `Choose ${left} ${left === 1 ? 'more scrub' : 'scrubs'}` : `Add box to cart · ${this.money(Number(this.dataset.price))}`;
    }
    async addToCart() {
      if (this.busy || this.chosen.length !== 3 || this.hasAttribute('data-unavailable')) return;
      this.busy = true;
      const error = this.querySelector('[data-error]');
      error.hidden = true;
      this.querySelector('[data-success]').hidden = true;
      const properties = Object.fromEntries(this.chosen.map((card, index) => [`Scrub ${index + 1}`, card.dataset.title]));
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
      this.submit.setAttribute('aria-busy', 'true');
      this.render();
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.dataset.variant), quantity: 1, properties }], sections: sections.join(','), sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Your box could not be added. Please try again.');
        this.dispatchEvent(new CartAddEvent({}, this.dataset.variant, { source: 'build-your-box', itemCount: 1, variantId: this.dataset.variant, sections: data.sections }));
        this.querySelector('[data-success]').hidden = false;
        this.chosen = [];
      } catch (err) {
        error.textContent = err.message || 'Please check your connection and try again.';
        error.hidden = false;
      } finally {
        this.busy = false;
        this.submit.removeAttribute('aria-busy');
        this.render();
      }
    }
  });
}
